export const roundNumber = (number) => {
    return Number(Math.round(number));
}